/**
 * Contrato zod del cliente de ACSIS (maestro del destino del despacho).
 *
 * El backend hace proxy de `/api/requests/obtener/cliente/:id.json` y
 * normaliza el shape. Los campos `tipoActorSnt` y `domicilios[].gln` hoy
 * pueden venir null/vacíos — pendiente de configuración en ACSIS.
 */

import { z } from 'zod';

export const ClienteDomicilioSchema = z.object({
  renglon: z.string().nullable(),
  direccion: z.string().nullable(),
  localidad: z.string().nullable(),
  provincia: z.string().nullable(),
  pais: z.string().nullable(),
  codigoPostal: z.string().nullable(),
  telefono: z.string().nullable(),
  email: z.string().nullable(),
  /** GLN destino — viene del campo `barrio` de ACSIS. Hoy en blanco. */
  gln: z.string().nullable(),
  esPrincipal: z.boolean(),
  utilizable: z.boolean(),
});

export const ClienteSchema = z.object({
  id: z.string().nullable(),
  nombre: z.string().nullable(),
  nombreLegal: z.string().nullable(),
  cuit: z.string().nullable(),
  tipoCliente: z.string().nullable(),
  /** Tipo agente SNT (clasificador2 de ACSIS) — hoy null. */
  tipoActorSnt: z.string().nullable(),
  condicionIva: z.string().nullable(),
  fechaAlta: z.string().nullable(),
  fechaBaja: z.string().nullable(),
  domicilios: z.array(ClienteDomicilioSchema),
  /** JSON crudo devuelto por ACSIS — para el modal "ver log". Optional
   *  para mantener compat con snapshots viejos del backend que no lo enviaban. */
  raw: z.unknown().optional(),
});

export type ClienteDomicilio = z.infer<typeof ClienteDomicilioSchema>;
export type Cliente = z.infer<typeof ClienteSchema>;
